export function socket(state = {}, action) {
	switch (action.type) {
		case 'SOCKET_DATA':
			return action.data;
		default:
			return state;
	}
}